/**
 * Inline SVG icon set, ported from mockup_v4.html.
 * Returned as HTML strings — bind via v-html where necessary.
 */
const wrap = (path: string): string =>
  `<svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24">${path}</svg>`

export const ICONS: Record<string, string> = {
  dashboard: wrap('<path d="M3 13l9-9 9 9M5 11v9h14v-9"/>'),
  targets: wrap('<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5"/>'),
  inventory: wrap('<rect x="3" y="4" width="18" height="6" rx="1"/><rect x="3" y="14" width="18" height="6" rx="1"/>'),
  findings: wrap('<path d="M12 2l2.39 7.36H22l-6.18 4.49L18.18 21 12 16.51 5.82 21 8.18 13.85 2 9.36h7.61z"/>'),
  ai_triage: wrap('<path d="M9 3a4 4 0 00-3.5 6 4 4 0 000 6 4 4 0 003.5 6V3zM15 3a4 4 0 013.5 6 4 4 0 010 6 4 4 0 01-3.5 6V3z"/><path d="M9 9h6M9 15h6"/>'),
  monitor: wrap('<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>'),
  s_workspace: wrap('<rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/>'),
  s_pipeline: wrap('<circle cx="12" cy="6" r="3"/><circle cx="12" cy="18" r="3"/><path d="M12 9v6"/>'),
  s_tools: wrap('<path d="M14.7 6.3a1 1 0 010 1.4l-7 7a1 1 0 01-1.4 0l-2-2a1 1 0 010-1.4l7-7a1 1 0 011.4 0zM5 19h14"/>'),
  s_proxies: wrap('<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 10h18M8 4v6M16 4v6"/>'),
  s_ai: wrap('<rect x="6" y="3" width="12" height="18" rx="2"/><circle cx="12" cy="9" r="1.5"/><path d="M9 14h6M9 17h4"/>'),
  s_notify: wrap('<path d="M15 17h5l-1.4-1.4A2 2 0 0118 14.2V11a6 6 0 10-12 0v3.2a2 2 0 01-.6 1.4L4 17h5m6 0a3 3 0 11-6 0"/>'),
  s_templates: wrap('<rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 9h6M9 13h6M9 17h3"/>'),
  s_network: wrap('<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 010 18M12 3a14 14 0 000 18"/>'),
  s_i18n: wrap('<path d="M3 5h12M9 3v2c0 5-4 9-6 9M5 9c0 5 6 9 12 9M14 14h7M17 14l-3 7M17 14l3 7M15 19h5"/>'),
}
